// _viewportAnimations.js

import { getGSAP } from './_gsap.js';

export function initViewportAnimations() {
  const gsap = getGSAP();

  const animateElement = (element) => {
    gsap.fromTo(element, 
      { autoAlpha: 0, y: 50 },
      { 
        duration: 1, 
        autoAlpha: 1, 
        y: 0, 
        ease: "power3.out",
        overwrite: "auto"
      }
    );
  };

  const createObserver = (element) => {
    const threshold = parseFloat(element.dataset.threshold) || 0.2; // Valeur par défaut de 20%

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateElement(element);
          observer.unobserve(element);
        }
      });
    }, { threshold: threshold });

    observer.observe(element);
  };

  // Sélectionner tous les éléments avec data-reveal="viewport"
  const revealElements = document.querySelectorAll('[data-reveal="viewport"]');

  revealElements.forEach(element => {
    // Vérifier si l'élément est déjà dans le viewport au chargement
    const rect = element.getBoundingClientRect();
    const threshold = parseFloat(element.dataset.threshold) || 0.2;
    
    if (rect.top < window.innerHeight * (1 - threshold)) {
      // L'élément est déjà visible, animer immédiatement
      animateElement(element);
    } else {
      // L'élément n'est pas encore visible, créer un observer
      createObserver(element);
    }
  });
}